import React from "react";
import FileView from "../../pages/FileViewPage";

export default function ClientFilePreviewer({ fileInfo, closeDrawer }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        flex: 1,
        minHeight: 0,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          flex: 1,
          minHeight: 0,
          height: "100%",
          overflow: "hidden",
        }}
      >
        <FileView
          fileInfo={fileInfo}
          closeDrawer={closeDrawer}
          sharedFileInfo={{}}
          embedded={true}
        />
      </div>
    </div>
  );
}
